import React from 'react';
import ServiceOrdersAdminLayout from '../components/administration/ServiceOrdersAdminLayout';

function ServiceOrdersAdminPage() {
  return <ServiceOrdersAdminLayout />;
}

export default ServiceOrdersAdminPage;
